<template>
  <div class="search__nav">
    <div class="search__nav__title">
      <div class="search__nav__tags">
        <span>当前搜索：</span>
        <span v-if="searchText" style="margin-right:12px">{{ `"${searchText}"` }}</span>
        <SearchTag v-for="(value, key) in chooseClass" :tab="value" :key="key" @close="handleCloseTag" />
      </div>
      <div class="search__nav__classify">
        <div v-if="firstList.length" class="search__nav__classify__row">
          <div class="search__nav__classify__row__title">一级分类</div>
          <div class="search__nav__classify__row__content">
            <ShowMore>
              <div
                v-for="category in firstList"
                :key="category.displayCategoryCode"
                :class="{
                  search__nav__classify__row__content__item: true,
                  pointer: true,
                  active: category.displayCategoryCode == chooseFirstListValue
                }"
                @click="chooseFirstList(category)"
              >
                {{ category.displayCategoryName }}
              </div>
            </ShowMore>
          </div>
        </div>
        <div v-if="secondList.length" class="search__nav__classify__row">
          <div class="search__nav__classify__row__title">二级分类</div>
          <div class="search__nav__classify__row__content">
            <ShowMore>
              <div
                v-for="category in secondList"
                :key="category.displayCategoryCode"
                :class="{
                  search__nav__classify__row__content__item: true,
                  pointer: true,
                  active: category.displayCategoryCode == chooseSecondListValue
                }"
                @click="chooseSecondList(category)"
              >
                {{ category.displayCategoryName }}
              </div>
            </ShowMore>
          </div>
        </div>
        <div v-if="thirdList.length" class="search__nav__classify__row">
          <div class="search__nav__classify__row__title">三级分类</div>
          <div class="search__nav__classify__row__content">
            <ShowMore>
              <div
                v-for="category in thirdList"
                :key="category.displayCategoryCode"
                :class="{
                  search__nav__classify__row__content__item: true,
                  pointer: true,
                  active: category.displayCategoryCode == chooseThirdListValue
                }"
                @click="chooseThirdList(category)"
              >
                {{ category.displayCategoryName }}
              </div>
            </ShowMore>
          </div>
        </div>
        <div v-if="search.itemAggFactoryNames && search.itemAggFactoryNames.length" class="search__nav__classify__row">
          <div class="search__nav__classify__row__title">厂家</div>
          <div class="search__nav__classify__row__content">
            <ShowMore>
              <div
                v-for="factory in search.itemAggFactoryNames"
                :key="factory"
                :class="{
                  search__nav__classify__row__content__item: true,
                  pointer: true,
                  active: factory == chooseFactoryValue
                }"
                @click="chooseFactory(factory)"
              >
                {{ factory }}
              </div>
            </ShowMore>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import SearchTag from './SearchTag';
import ShowMore from './ShowMore';
export default {
  props: {
    search: {
      type: Object,
      default: () => {
        return {
          itemCategories: [],
          itemAggFactoryNames: []
        };
      }
    }
  },
  components: {
    SearchTag,
    ShowMore
  },
  computed: {
    searchText() {
      return this.$route.query.text || '';
    }
  },
  watch: {
    search: {
      handler(val) {
        this.firstList = val.itemCategories || [];
        if (!this.firstList.length) return;
        this.secondList = this.firstList[0].children;
        this.thirdList = this.secondList[0].children;
      }
    }
  },
  data() {
    return {
      firstList: [],
      secondList: [],
      thirdList: [],
      chooseFirstListValue: null,
      chooseSecondListValue: null,
      chooseThirdListValue: null,
      chooseFactoryValue: null,
      chooseClass: new Map()
    };
  },
  methods: {
    // 重置分类选择
    resetSelectCategory() {
      this.chooseFirstListValue = null;
      this.chooseSecondListValue = null;
      this.chooseThirdListValue = null;
    },
    // 选择一级分类
    chooseFirstList({ displayCategoryName, displayCategoryCode }) {
      this.resetSelectCategory();
      this.autoSelectCategory('分类', { displayCategoryName, displayCategoryCode });
      this.chooseFirstListValue = displayCategoryCode;
      this.firstList.forEach(ele => {
        if (ele.displayCategoryCode == displayCategoryCode) this.secondList = ele.children;
      });
      this.searchChange();
    },
    // 选择二级分类
    chooseSecondList({ displayCategoryName, displayCategoryCode }) {
      this.resetSelectCategory();
      this.autoSelectCategory('分类', { displayCategoryName, displayCategoryCode });
      this.chooseSecondListValue = displayCategoryCode;
      this.secondList.forEach(ele => {
        if (ele.displayCategoryCode == displayCategoryCode) this.thirdList = ele.children;
      });
      this.searchChange();
    },
    // 选择三级分类
    chooseThirdList({ displayCategoryName, displayCategoryCode }) {
      this.resetSelectCategory();
      this.autoSelectCategory('分类', { displayCategoryName, displayCategoryCode });
      this.chooseThirdListValue = displayCategoryCode;
      this.searchChange();
    },
    // 选择厂家
    chooseFactory(factory) {
      this.autoSelectCategory('厂家', factory);
      this.chooseFactoryValue = factory;
      this.searchChange();
    },
    // 搜索类目发生改变
    searchChange() {
      this.$emit('change', {
        categoryCode: this.chooseThirdListValue || this.chooseSecondListValue || this.chooseFirstListValue,
        itemFactoryNames: this.chooseFactoryValue
      });
    },
    handleCloseTag([title, content]) {
      this.chooseClass.delete(title);
      if (title == '厂家') {
        this.chooseFactoryValue = null;
      } else if (title == '分类') {
        this.chooseFirstListValue = null;
        this.chooseSecondListValue = null;
        this.chooseThirdListValue = null;
      }
      this.searchChange();
    },
    autoSelectCategory(title, content) {
      this.chooseClass.set(title, content);
    }
  }
};
</script>

<style lang="scss" scoped>
.search__nav {
  padding-top: 12px;
  &__title {
    font-size: 12px;
    font-weight: 400;
    color: #595959;
    line-height: 1;
  }
  &__tags {
    display: flex;
    height: 26px;
    align-items: center;
    flex-wrap: wrap;
  }
  &__classify {
    display: table;
    border-collapse: collapse;
    width: 100%;
    margin-top: 12px;
    &__row {
      display: table-row;
      &__title,
      &__content {
        display: table-cell;
        border: 1px solid #eeeeee;
      }
      &__title {
        width: 100px;
        padding: 18px 16px;
        font-size: 12px;
        font-weight: 500;
        color: #595959;
        line-height: 1;
      }
      &__content {
        padding: 10px 12px 10px 0;
        font-size: 12px;
        font-weight: 400;
        color: #595959;
        line-height: 1;
        background: #ffffff;
        &__item {
          display: inline-block;
          padding: 0 12px;
          height: 32px;
          line-height: 32px;
        }
      }
    }
  }
  .active {
    color: #d96900;
  }
  ::v-deep .el-checkbox__label {
    font-size: 12px;
    font-weight: 400;
    color: #595959;
  }
}
</style>
